/* eslint-disable */
// generate string of length 20
const codepku = {};
codepku.genUniqueId = function () {
  const randomStr = Math.random().toString(36).substr(2) + Math.random().toString(36).substr(2);
  return randomStr.substr(0, 20);
};

// 浏览器内核判断
codepku.browserType = function () {
  const explorer = window.navigator.userAgent;
  const obj = {
      type: '',
      name: '',
      version: 0,
  };
  let strStart; let
strStop = '';
  const re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/;
  if (explorer.indexOf('NET') >= 0 && explorer.indexOf('rv') >= 0) {
      obj.type = 'IE';
      strStart = explorer.indexOf('rv');
      strStop = explorer.indexOf(')');
      obj.name = explorer.substring(strStart, strStop);
      const m = obj.name.toLowerCase().match(re);
      obj.version = m[2] || 0;
      return obj;
  } if (explorer.indexOf('Firefox') >= 0) {
      obj.type = 'Firefox';
      strStart = explorer.indexOf('Firefox');
      obj.name = explorer.substring(strStart);
      const m = obj.name.toLowerCase().match(re);
      obj.version = m[2];
      return obj;
  } if (explorer.indexOf('Chrome') >= 0) {
      obj.type = 'Chrome';
      strStart = explorer.indexOf('Chrome');
      strStop = explorer.indexOf(' Safari');
      obj.name = explorer.substring(strStart, strStop);
      const m = obj.name.toLowerCase().match(re);
      obj.version = m[2] || 0;
      return obj;
  } if (explorer.indexOf('Opera') >= 0) {
      obj.type = 'Opera';
      obj.name = 'Opera';
      const m = obj.name.toLowerCase().match(re);
      obj.version = m[2];
      return obj;
  } if (explorer.indexOf('Safari') >= 0) {
      obj.type = 'Safari';
      strStart = explorer.indexOf('Firefox');
      obj.name = explorer.substring(strStart);
      const m = obj.name.toLowerCase().match(re);
      obj.version = m[2];
      return obj;
  }
};

export default codepku;
